import currentTheme from "../../../react-themes/theme";
import React from "react";

const theme = currentTheme();
const defaultGap = `${theme.columns.gaps.md}px`;
const defaultWidth = "100%";

export const FarmyColumnSet = (props) => {
  const {children, className = "", style} = props;

  return (
    <div
      className={`farmy-column-set ${className}`}
      style={{
        gap: props?.gap || defaultGap,
        ...style
      }}>
      {children}
    </div>
  );
};

export const FarmyColumn = (props) => {
  const {children, className = "", style} = props;

  return (
    <div
      className={`farmy-column ${props?.strict ? "flex-grow-0 flex-shrink-0" : ""} ${className}`}
      style={{
        flexBasis: props?.width || defaultWidth,
        maxWidth: props?.strict && props?.width ? props.width : "100%",
        ...style
      }}>
      {children}
    </div>
  );
};
